
(function () {

  function installStubs(Alpine) {
    var stubs = {
      xPopupInsurance: { open: false, openInsuranceNoti: false, openInsuranceShipping: false, loading: false },
      xPopupShipping:  { open: false, openShipping: false, loading: false }
    };
    Object.keys(stubs).forEach(function (name) {
      try { if (!Alpine.store(name)) Alpine.store(name, stubs[name]); } catch (e) {}
    });
  }
  if (window.Alpine && window.Alpine.store) {
    installStubs(window.Alpine);
  } else {
    document.addEventListener('alpine:init', function () { installStubs(window.Alpine); });
  }

  window.xUpsellCard = function (initialState) {
    initialState = initialState || {};
    return {
      product: initialState.product || null,
      selectedVariantId: initialState.variantId || null,
      loading: false,
      errorMessage: false,
      siblingHandles: initialState.siblingHandles || {},
      highlight: initialState.highlight || '',
      money_format: initialState.money_format || '${{amount}}',

      init: function () {
        if (!this.product) return;
        if (!this.selectedVariantId && this.product.variants && this.product.variants.length) {
          var firstAvail = this.product.variants.find(function (v) { return v.available; });
          this.selectedVariantId = (firstAvail || this.product.variants[0]).id;
        }
      },

      get currentVariant() {
        if (!this.product || !this.product.variants) return null;
        var sel = this.selectedVariantId;
        return this.product.variants.find(function (v) { return v.id == sel; }) || this.product.variants[0];
      },

      get displayImage() {
        var v = this.currentVariant;
        if (v && v.featured_image && v.featured_image.src) return this.upgradeImage(v.featured_image.src, 600);
        if (this.product && this.product.featured_image) return this.upgradeImage(this.product.featured_image, 600);
        return '';
      },

      get displayPrice() {
        var v = this.currentVariant;
        var price = v ? v.price : (this.product ? this.product.price : 0);
        return this.formatMoney(price);
      },

      get displayComparePrice() {
        var v = this.currentVariant;
        var cmp = v ? v.compare_at_price : null;
        if (!cmp || cmp <= (v ? v.price : 0)) return null;
        return this.formatMoney(cmp);
      },

      get isAvailable() {
        var v = this.currentVariant;
        return v ? v.available : false;
      },

      get displayTitle() {
        if (this.product && this.product.metafields_custom_title) return this.product.metafields_custom_title;
        return this.product ? this.product.title : '';
      },

      get displaySubtitle() {
        if (this.highlight) return this.highlight;
        var v = this.currentVariant;
        if (v && v.title && v.title !== 'Default Title') return v.title;
        return '';
      },

      pickSibling: function (handle, selectEl) {
        var self = this;
        if (!handle || this.loading) return;
        if (this.product && this.product.handle === handle) return;
        this.loading = true;
        this.errorMessage = false;
        // Read the custom metafields straight off the chosen <option>,
        // since the .js endpoint below carries no metafields.
        var optTitle = null, optHighlight = null;
        if (selectEl && selectEl.querySelector) {
          var opt = selectEl.querySelector('option[value="' + handle + '"]');
          if (opt) {
            optTitle = opt.getAttribute('data-title');
            optHighlight = opt.getAttribute('data-highlight');
          }
        }
        return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (res) { if (!res.ok) throw new Error('Fetch failed: ' + res.status); return res.json(); })
          .then(function (data) {
            self.product = data;
            // Re-attach the custom title so displayTitle keeps showing the metafield.
            if (optTitle) self.product.metafields_custom_title = optTitle;
            var firstAvail = data.variants.find(function (v) { return v.available; });
            self.selectedVariantId = (firstAvail || data.variants[0]).id;
            // Prefer the option's highlight metafield; fall back to variant title.
            self.highlight = optHighlight || ((firstAvail && firstAvail.title) ? firstAvail.title : '');
          })
          .catch(function (e) {
            console.error('[xUpsellCard] Sibling fetch failed:', e);
            self.errorMessage = 'Failed to load';
          })
          .then(function () { self.loading = false; });
      },

      pickVariant: function (variantId) {
        this.selectedVariantId = parseInt(variantId, 10);
      },

      addToCart: function () {
        var self = this;
        if (!this.selectedVariantId || this.loading || !this.isAvailable) return;
        this.loading = true;
        this.errorMessage = false;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: this.selectedVariantId, quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) return res.json().catch(function () { return {}; }).then(function (err) {
              throw new Error(err.description || err.message || 'Add to cart failed');
            });
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            document.dispatchEvent(new CustomEvent('eurus:cart-drawer:refresh'));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            try {
              if (window.Alpine) {
                var mc = window.Alpine.store('xMiniCart');
                if (mc) { mc.open = true; mc.loading = true; }
              }
            } catch (e) {}
            return fetch(window.location.pathname + '?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } });
          })
          .then(function (sectionRes) {
            if (sectionRes && sectionRes.ok) return sectionRes.text();
            return null;
          })
          .then(function (html) {
            if (html) {
              var cur = document.getElementById('CartDrawer');
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.getElementById('CartDrawer');
              if (cur && fresh) {
                cur.replaceWith(fresh);
                if (window.Alpine && window.Alpine.initTree) window.Alpine.initTree(fresh);
              }
            }
            try {
              if (window.Alpine) {
                var mc2 = window.Alpine.store('xMiniCart');
                if (mc2) { mc2.open = true; mc2.loading = false; }
              }
            } catch (e) {}
          })
          .catch(function (e) {
            console.error('[xUpsellCard] addToCart failed:', e);
            self.errorMessage = e.message || 'Add to cart failed';
            setTimeout(function () { self.errorMessage = false; }, 3500);
          })
          .then(function () { self.loading = false; });
      },

      upgradeImage: function (src, width) {
        if (!src) return '';
        try {
          var url = new URL(src, window.location.origin);
          url.searchParams.set('width', width);
          return url.toString();
        } catch (e) { return src; }
      },

      formatMoney: function (cents) {
        if (typeof cents !== 'number') return '';
        var amount = cents / 100;
        var formatted = amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return this.money_format
          .replace('{{amount}}', formatted)
          .replace('{{amount_no_decimals}}', Math.round(amount).toLocaleString())
          .replace('{{amount_with_comma_separator}}', formatted.replace('.', ','));
      }
    };
  };
})();